import CallManageDetailComponent from './component';

class CallManageDetailRoute extends CallManageDetailComponent {

}

export default CallManageDetailRoute;
